<template>
  <div class="min-h-screen bg-gray-50 px-4 pt-6 pb-28" dir="rtl">
    <div class="max-w-4xl mx-auto md:max-w-lg space-y-4">
      <div v-if="attach_items.length > 0" class="space-y-3">
        <div
          v-for="item in attach_items"
          :key="item.Id"
          class="bg-white rounded-xl border border-gray-200 p-4 hover:shadow-md hover:border-blue-300 transition-all duration-200"
        >
          <h3 class="text-sm font-bold text-gray-900 mb-2 leading-6">{{ item.RequestName }}</h3>

          <p class="text-xs text-gray-500 mb-3">
            {{ $t('imageName') }}
            <span class="font-semibold text-gray-800">{{ item.ImageName }}</span>
          </p>

          <a
            :href="item.ImagePath"
            target="_blank"
            rel="noopener noreferrer"
            class="block rounded-lg overflow-hidden border border-gray-100 bg-gray-50"
          >
            <img
              :src="item.ImagePath"
              :alt="item.ImageName || item.RequestName"
              class="w-full h-40 object-cover"
              loading="lazy"
            />
          </a>
        </div>
      </div>

      <div
        v-else
        class="bg-white rounded-xl border border-dashed border-gray-300 p-12 text-center"
      >
        <div class="max-w-2xl mx-auto">
          <div class="w-20 h-20 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
            <svg class="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          <p class="text-gray-500 font-medium mb-2">پیوستی وجود ندارد</p>
          <p class="text-sm text-gray-400">برای این درخواست هنوز تصویری ثبت نشده است</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'passing_data'
  ],
  data () {
    return {
      list: [],
      errors: [],
      post_items: [],
      selected_post: 0,
      selected_branch: 0,
      attach_items: [],
      show_loading: false,
      page: 0,
      first: true,
    }
  },
  components: {
  },
  watch: {
  },
  mounted () {
    this.get_attachs()
  },
  methods: {
    goToDetail (item) {
      if (item.IsFinalize == 1) {
        this.$router.push({ name: 'ViewRequest', params: { rec_id: item.Id } })
      } else {
        this.$router.push({ name: 'ViewPreRequest', params: { rec_id: item.Id } })
      }
    },
    get_attachs () {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        ReqId: this.$route.params.rec_id,
        IsFinalize: 1,
      }
      this.axios.post('/GetUserRequestImages', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.attach_items = response.data.results
          }
        }).catch(e => {
          this.errors.push(e)
        })
    },
  }
}
</script>
